import React from 'react';
import './About.css';

export default function About() {
  const aboutImage = '/Personalphoto1.jpg';

  return (
    <section className="section about anchor" id="about">
      <div className="container about__inner">
        <div className="about__media">
          <img className="about__image" src={aboutImage} alt="Emmanuel Obeng" loading="lazy" />
        </div>
        <div className="about__content">
          <h2 className="about__title">Hi, I’m Emmanuel Obeng</h2>
          <p className="about__role">PMP® Certified Project Manager &amp; IT Specialist</p>
          <p className="about__text">
            With over <strong>7 years of experience</strong> across{' '}
            <strong>Banking, FinTech, and IT services</strong>, I specialise in rescuing delayed
            projects, stabilising IT environments, and building the delivery structures that teams
            need to actually ship - not just plan.
          </p>
          <p className="about__text">
            I've seen what breaks delivery: unclear ownership, no risk visibility, reactive support
            with no process, and engineering teams running without a real execution framework. I fix
            those things directly - using structured Agile delivery, ITIL 4-based service
            management, and hands-on stakeholder leadership.
          </p>
          <div className="about__chips" aria-label="Specialties">
            <span className="about__chip">Jira · Confluence</span>
            <span className="about__chip">Agile &amp; Scrum</span>
            <span className="about__chip">ITIL 4 Service Mgmt</span>
            <span className="about__chip">Risk &amp; Change Mgmt</span>
            <span className="about__chip">Security+</span>
            <span className="about__chip">Banking &amp; FinTech</span>
          </div>
        </div>
      </div>
    </section>
  );
}
